import {OrderChangeQuantityRange} from '../../options/types'
import {OrderConfirmationContextProps} from '../context/OrderConfirmationContext'

export const buildConfiguration = (
  quantityRange: OrderChangeQuantityRange
): OrderConfirmationContextProps => {
  if (!quantityRange.orderConfirmation) {
    return {isEnabled: false}
  }

  return {
    isEnabled: true,
    quantityRange: {
      ...quantityRange.orderConfirmation,
      default: quantityRange.orderConfirmation.default ?? quantityRange.default
    }
  }
}
